import { Modal } from 'antd'
import { observer } from 'mobx-react-lite'
import { useCallback, useEffect, useState } from 'react'

import { useStore } from 'store/useStore'
import { Button } from 'components/uiKit'

const TIME_CHECK_OFFER = 60 * 15 * 1000 // 15 минут

export const OfferModal = observer(() => {
  const { offerStore: uiStore, appStore } = useStore()
  const [stage, setStage] = useState(0)
  const [sending, setSending] = useState(false)
  const [isOfertaPageLoading, setOfertaPageLoading] = useState<boolean>(true)

  useEffect(() => {
    const versionOfferIntervalId = setInterval(uiStore.checkOfferVersion, TIME_CHECK_OFFER)

    if (!appStore.user.authenticated) {
      clearInterval(versionOfferIntervalId)
    }
    setTimeout(async () => {
      uiStore.checkOfferVersion()
    }, 0)
    return () => {
      clearInterval(versionOfferIntervalId)
    }
  }, [appStore.user.authenticated])

  const onFinishPress = async () => {
    setSending(true)
    try {
      await Promise.all(
        uiStore.offersForSign.map((offer) => {
          return uiStore.apiStore.signOfferVersion({
            version: offer.lastVersion,
            countryCode: offer.countryCode,
          })
        }),
      )

      uiStore.setModalVisible(false)
    } finally {
      setSending(false)
    }
  }

  const handleAcceptPress = useCallback(async () => {
    let nextStage = stage

    if (stage < uiStore.linksForOfferModal.length - 1) {
      setOfertaPageLoading(true)
      nextStage = nextStage + 1
    } else {
      await onFinishPress()
      nextStage = 0
    }

    setStage(nextStage)
  }, [stage, setStage, uiStore.linksForOfferModal])

  return (
    <Modal
      title="Оферта"
      open={uiStore.modalVisible}
      onOk={handleAcceptPress}
      closeIcon={false}
      width={'90vw'}
      footer={[
        <Button loading={sending || isOfertaPageLoading} key="submit" type="primary" onClick={handleAcceptPress}>
          {stage === uiStore.linksForOfferModal.length - 1 ? 'Принять' : 'Далее'}
        </Button>,
      ]}
    >
      <iframe
        style={{ width: '100%', height: '70vh' }}
        onLoad={() => setOfertaPageLoading(false)}
        src={uiStore.linksForOfferModal[stage]}
      />
    </Modal>
  )
})
